'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTooltip;
/**
 * Returns tooltip message for field.
 * @param {Object} tooltipInfo - Data object (parsed JSON) represents the tooltip data.
 * @param {string} pageCode - Code (slug) of the page.
 * @param {string} sectionCode - Code (slug) of the section (form).
 * @param {string} fieldCode - Code (slug) of the field.
 * @return {string} - Tooltip message.
 */
function getTooltip(tooltipInfo, pageCode, sectionCode, fieldCode) {
    var message = '';

    if (tooltipInfo && pageCode && sectionCode && fieldCode && tooltipInfo.pages.length) {
        var page = tooltipInfo.pages.find(function (page) {
            return page.code === pageCode;
        });
        if (page && page.sections.length) {
            var section = page.sections.find(function (section) {
                return section.code === sectionCode;
            });
            if (section && section.fields.length) {
                var field = section.fields.find(function (field) {
                    return field.code === fieldCode;
                });
                if (field) {
                    message = field.tooltip;
                }
            }
        }
    }

    return message;
}